/**
 * FICHIER GÉNÉRÉ — ne pas modifier à la main.
 *
 * Produit par `npm run measure:facing`. Pour chaque asset orienté, la direction de
 * grille vers laquelle son sprite de rotation 0 regarde : 0 nord, 1 est, 2 sud, 3 ouest.
 *
 * Mesurée dans l'espace du MODÈLE — nœuds de roues pour les véhicules, centre de gravité
 * de la tranche haute pour les décors — puis vérifiée sur le sprite rendu. Voir
 * `facing.ts` pour la loi qui transforme cette direction de base en indice de rotation.
 *
 * Les assets absents de cette table n'ont pas d'orientation lisible : tree1, tree2, tree3, bush1, rock1, rock2, bin, potplants.
 * Le jeu ne les tourne pas — inventer un avant à une poubelle cylindrique serait aussi
 * faux que de l'orienter au hasard.
 */

export const BASE_FACING: Readonly<Record<string, number>> = {
  streetLight: 2,
  bench: 2,
  trafficLight: 2,
  stopSign: 2,
  'car-1': 2,
  'car-2': 2,
  'car-3': 2,
  'car-4': 2,
};
